import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8d3e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "student-import-school-year-area-container" }
const _hoisted_2 = { class: "school-year-area-main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "school-year-area-main__text" }, "のデータとして登録する", -1))
const _hoisted_4 = { class: "message-area" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message-area__row" }, "学年・クラス・出席番号は、この年度に設定されます。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message-area__row" }, "その他の項目は、年度に関わらず上書きされます。", -1))
const _hoisted_7 = { class: "message-area__row margin-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchoolYearSwitch = _resolveComponent("SchoolYearSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SchoolYearSwitch, {
        class: "school-year-switch",
        "school-year": _ctx.schoolYear,
        enabled: _ctx.enabled,
        "on-change": _ctx.onInput,
        "number-font-size": 18,
        "unit-font-size": 15,
        "arrow-size": 12,
        bold: true
      }, null, 8, ["school-year", "enabled", "on-change"]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, "また、ここでは" + _toDisplayString(_ctx.googleMailDisplayName) + "は更新できません。", 1)
    ])
  ]))
}